import { useEffect, useState } from 'react';
import { post } from './api';
import { startPrinterMonitor } from './printer-monitor';

export function usePrinterMonitor(ids: string[], enabled: boolean, userId?: string, surface: 'print' | 'setup' = 'print') {
 const [error, setError] = useState('');
 const key = [...new Set(ids)].sort().slice(0,20).join(',');
 useEffect(() => {
  setError('');
  if (!enabled || !key || !userId) return;
  const viewId = crypto.randomUUID();
  return startPrinterMonitor({
   renew: () => post('/printing/monitor', { viewId, printerIds:key.split(','), surface }, { feedback:false }),
   visible: () => document.visibilityState === 'visible',
   subscribe: listener => { document.addEventListener('visibilitychange',listener); return () => document.removeEventListener('visibilitychange',listener); },
   onError: setError,
  });
 }, [key, enabled, userId, surface]);
 return error;
}
